import React, { PropsWithChildren } from 'react'

import styled from '@emotion/styled'
import { useTheme } from '@gousto-internal/citrus-react'
import { GetStartedProps } from './GetStarted'

export const GetStartedWrapper = (
  props: PropsWithChildren<Omit<GetStartedProps, 'getStartedText'>>,
) => {
  const { theme } = useTheme()

  const smallBreakpoint = theme.tokens.breakpoints[0]
  const breakpointToMedium = `@media (max-width: ${smallBreakpoint})`

  const { maxHeight, isSticky, ctaRef, isHeroCTA } = props

  const Component = styled.div({
    display: 'none',

    [breakpointToMedium]: {
      display: 'block',
      padding: '0.75rem',
      background: theme.tokens.colors.White,
      position: 'fixed',
      bottom: '0',
      width: '100%',
      zIndex: '5',
      margin: '0 -0.75rem',
      boxShadow: '0 -0.25rem 3rem rgba(0, 0, 0, 0.2)',
      ...(isSticky
        ? {
            transform: 'translateY(0)',
            transformOrigin: 'bottom',
            transition: 'transform 0.3s ease',
          }
        : {
            transformOrigin: 'bottom',
            transform: 'translateY(31.25rem)',
            transition: 'transform 0.3s ease',
          }),
      ...(isSticky && maxHeight
        ? {
            bottom: 'auto',
            boxShadow: 'none',
          }
        : {}),
      ...(maxHeight && !isHeroCTA ? { top: `${maxHeight}px` } : {}),
    },
  })

  // eslint-disable-next-line react/jsx-props-no-spreading
  return <Component {...props} ref={ctaRef} />
}
